module.exports = __webpack_public_path__ + "static/img/grade_14.05be2b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/oralT/img/grade_14.png
// module id = esY9
// module chunks = 80